import Dexie from "dexie";

export const dbName ='DumbCRM_v9';
const options = { autoOpen: true };
export const db = new Dexie(dbName, options);
export const dbVersion = 1;
